import React from 'react';
import { Col, Form, FormGroup, Input, Label, Row } from 'reactstrap';

import {LangController} from "../../../components/tabs/langController";

const LabelLangs = props => {
    const setDataDefault = (activeLangs, setLangChilds) => {
        const items = activeLangs.map( lang => ({
            id: '',
            lang: { id:lang?.id, name:lang?.name, showOrder: lang?.showOrder },
            name : ''
        }) )
        setLangChilds(items);
    }

    const getFormulary = (child, index, disableInputs, onInputChange) => {
        return (
            <Form>
                <Row>
                    <Col md="12">
                        <FormGroup>
                            <Label >Nombre</Label>
                            <Input type="textarea"
                                   name="name"
                                   rows="8"
                                   placeholder="Ingrese el nombre"
                                   value= { child.name }
                                   onChange={e => onInputChange(e, child.lang)}
                                   disabled={disableInputs}
                            />
                        </FormGroup>
                    </Col>
                </Row>
            </Form>
        );
    }

    return(<LangController
        langs={props.langs}
        setLangs={props.setLangs}
        getFormulary={getFormulary}
        setDataDefault={setDataDefault}
        translatableLangs={props.translatableLangs}
    />)
}

export default LabelLangs